import React from 'react';
import { useFormContext, useWatch } from 'react-hook-form';
import { LenderMappingsFormValues } from 'modules/vendorOpportunity/dynamicLenderSubmissionMappings/types';
import { SelectField } from 'components/form';
import { LenderFieldMap } from '@trnsact/trnsact-shared-types';
import { getSelectMappingFieldOptions } from 'modules/vendorOpportunity/dynamicLenderSubmissionMappings/lib';
import { useEffect, useRef } from 'react';

interface Props {
  field: LenderFieldMap;
  inputProps: any;
  onValueChange: (lenderProperty: string, newValue: any) => void;
}

export const SelectMappingField = ({ field, inputProps, onValueChange }: Props) => {
  const {
    control,
    formState: { errors },
  } = useFormContext<LenderMappingsFormValues>();

  const options = getSelectMappingFieldOptions(field);

  const currentValue = useWatch({
    control,
    name: `mappingsByLenderFieldId.${field.lenderFieldId}.mappedValue`,
  });

  const prevValueRef = useRef(currentValue);

  useEffect(() => {
    if (prevValueRef.current !== currentValue && field.lenderProperty) {
      prevValueRef.current = currentValue;
      onValueChange(field.lenderProperty, currentValue);
    }
  }, [currentValue, field.lenderProperty, onValueChange]);

  return (
    <SelectField
      label={field.details?.displayName!}
      control={control}
      name={`mappingsByLenderFieldId.${field.lenderFieldId}.mappedValue`}
      options={options}
      variant="outlined"
      error={!!errors.mappingsByLenderFieldId?.[field.lenderFieldId!]?.mappedValue}
      required={field.details?.required === 'REQUIRED'}
    />
  );
};
